

import React, { useState, useEffect } from "react";
import axios from "axios";
import { API_BASE_URL } from "../../utils/config";
const GetAllNew = () => {
    const [parentCategories, setParentCategories] = useState([]);
    const [subcategories, setSubcategories] = useState([]);
    const [apiResponse, setApiRespose] = useState([])

    let bearerToken = sessionStorage.getItem('jwt_token');
    const config = {

        headers: {
            'Authorization': `Bearer ${bearerToken}`,
            'Content-Type': 'application/json',


        }
    };


    // 
    useEffect(() => {
        // alert("kjfvj")
        const apiUrl = `${API_BASE_URL}/wp-json/wp/v2/categories?per_page=100`
        axios.get(apiUrl, config).then((res) => {
            setApiRespose(res.data)
            console.log("res60=", res.data);
        }).catch((err) => {
            console.log(err);
        })
    }, []);

    //

    let getAllCat = [{
        id: 0,
        Image: '',
        title: '',
        content: [],

    }]
    let demoArr = [];
    for (let i = 0; i < apiResponse.length; i++) {
        demoArr.push({
            id: 0,
            Image: '',
            title: '',
            content: [],

        })
    }
    // console.log("demoArr1=", demoArr);
    for (let i = 0; i < apiResponse.length; i++) {
        // console.log(apiResponse.slug)
        if (apiResponse[i].parent == 0) {
            demoArr[i].title = apiResponse[i].name;
            demoArr[i].id = apiResponse[i].id;
        }

        for (let j = i + 1; j < apiResponse.length; j++) {
            if (apiResponse[i].id == apiResponse[j].parent) {
                demoArr[i].content.push(apiResponse[j])
                console.log("filterRes=", apiResponse[j]);
            }
        }
    }

    // console.log("demoArr2=", demoArr);

    const filteredArray = demoArr.filter(obj => obj.id !== 0);

    // Resulting array after filtering
    console.log(filteredArray);


    // 
    console.log("subCat=", subcategories);
    return (
        <div>
            <h2>Parent Categories:</h2>
            <ul>
                {parentCategories.map((parentCategory) => (
                    <li key={parentCategory.id}>
                        {parentCategory.name}
                    </li>
                ))}
            </ul>

            <h2>Subcategories:</h2>
            <ul>
                {subcategories.map((subcategory) => (
                    <li key={subcategory.id}>{subcategory.name}</li>
                ))}
            </ul>
        </div>
    );
};

export default GetAllNew;
